import { format, parse } from "date-fns";

import { isSetAndNotEmpty } from "@/utils/helpers";

import { HistoricalGuestPass } from "./GuestPassHistory";

type Props = {
  historicalGuestPass: HistoricalGuestPass;
};

export default function HistoricalGuestPassCard({
  historicalGuestPass: p,
}: Props) {
  const shareDate = isSetAndNotEmpty(p?.shareDate)
    ? format(parse(p?.shareDate, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
    : "";

  const guestName = isSetAndNotEmpty(p?.receiverFirstName)
    ? `${p?.receiverFirstName} ${p?.receiverLastName}`
    : null;
  return (
    <div className="mb-2 rounded-lg bg-clear-sky p-4">
      <div className="mb-5 flex justify-between">
        <div className="inline w-56 max-w-56 font-['Open_Sans'] text-base font-semibold leading-none text-teal-950">
          {`${p.description}`}
        </div>
        {p.isClaimed && (
          <div className="inline font-['Open_Sans'] text-sm font-semibold leading-none text-grass-green">
            Claimed
          </div>
        )}
      </div>
      <div className="flex items-center justify-start gap-11 self-stretch">
        <div className="flex w-full flex-col items-start justify-start gap-1">
          <div className="flex w-full items-center justify-start gap-2">
            <div className="font-['Open_Sans'] text-sm font-light leading-none text-teal-950">
              Date Shared:
            </div>
            <div className="font-['Open_Sans'] text-sm font-semibold leading-none text-teal-950">
              {shareDate}
            </div>
          </div>
          <div className="flex h-3 w-full items-center justify-start gap-2">
            <div className="font-['Open_Sans'] text-sm font-light leading-none text-teal-950">
              Share Method:
            </div>
            <div
              className="font-['Open_Sans'] text-sm font-semibold leading-none text-teal-950"
              style={{
                maxWidth: "62%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {p.shareMethod ? p.shareMethod : "URL Share"}
            </div>
          </div>
          <div className="flex h-3 w-full items-center justify-start gap-2">
            {guestName && (
              <>
                <div className="font-['Open_Sans'] text-sm font-light leading-none text-teal-950">
                  Guest Name:
                </div>
                <div
                  className="font-['Open_Sans'] text-sm font-semibold leading-none text-teal-950"
                  style={{
                    maxWidth: "66%",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {guestName}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
